import { useContext } from 'react';

import { useHistory } from 'react-router-dom';

import { ClassContext } from '../../context/ClassContext';
import { RosterProvider } from '../../context/RosterContext';
import Loadable from '../common/loadable';
import RosterView from '../roster/RosterView';

export const ClassroomRosterContent = () => {
    const history = useHistory();

    const {
        classData: {
            class: { sid: classId }
        },
        userUuid,
        classUuid,
        isLoadingClassData
    } = useContext(ClassContext);

    const handleRosterClose = () => {
        history.goBack();
    };

    if (isLoadingClassData || !classId) {
        return <Loadable isLoading fullScreen />;
    }

    return (
        <RosterProvider
            classId={classId.toString()}
            classUuid={classUuid}
            userUuid={userUuid}
            isDemo="false"
            onBack={handleRosterClose}
            narrowStyle
            fullScreen
        >
            <RosterView />
        </RosterProvider>
    );
};
